<template>
  <div class="float-service">
    <!-- 悬浮按钮（固定在右侧中间，位置不变） -->
    <div class="float-btn" @click="toggleShow">
      <van-button
          round
          :icon="showService ? 'cross' : 'service-o'"
          color="#4e9afe"
          class="btn-icon"
      />
    </div>

    <div
        v-if="showService"
        class="service-panel"
        :class="{ 'panel-visible': showService }"
    >
      <div class="panel-header">
        <h3>在线客服</h3>
      </div>

      <div class="contact-other">
        <van-grid :column-num="1" border="false">
          <van-grid-item icon="wechat" text="ymlz_web" />
          <van-grid-item icon="phone" text="15735414575" />
          <van-grid-item icon="envelop-o" text="654903383@qq.com" />
        </van-grid>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Cell, CellGroup, Grid, GridItem, Divider, Toast } from 'vant'

export default {
  components: {
    vanButton: Button,
    vanCell: Cell,
    vanCellGroup: CellGroup,
    vanGrid: Grid,
    vanGridItem: GridItem,
    vanDivider: Divider
  },
  data() {
    return {
      showService: false,
    }
  },
  methods: {
    toggleShow() {
      this.showService = !this.showService
    },
    contact(item) {
      Toast(`正在联系 ${item.name}...`)
    },
    showToast(msg) {
      Toast({ message: msg, duration: 2000 })
    }
  }
}
</script>

<style scoped>
/* 悬浮按钮：固定在右侧中间，不随页面滚动改变位置 */
.float-btn {
  position: fixed;
  right: 30px;
  bottom: 130px;
  transform: translateY(-50%);
  z-index: 999;
}

.btn-icon {
  width: 100px;
  height: 100px;
  box-shadow: 0 2px 8px rgba(78, 154, 254, 0.4);
}

/* 弹出面板：基于当前可视屏幕底部定位 */
.service-panel {
  position: fixed; /* 关键：固定在可视窗口 */
  bottom: -400px; /* 初始隐藏在屏幕底部外 */
  transform: translateX(-50%); /* 水平居中 */
  width: 90%;
  max-width: 320px;
  background: #fff;
  border-radius: 12px 12px 0 0; /* 顶部圆角，底部与屏幕贴合 */
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.1);
  transition: bottom 0.3s ease;
  z-index: 998; /* 低于按钮层级 */
}

/* 面板显示状态：滑到屏幕底部 */
.panel-visible {
  right: 0px;
  bottom: 150px; /* 贴合当前可视屏幕底部 */
}

/* 面板内容样式 */
.panel-header {
  font-size: 20px;
  padding: 20px;
  border-bottom: 1px solid #f5f5f5;
  text-align: center;
}

.panel-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}
</style>